import { render } from "./EditPR.vue?vue&type=template&id=4471e0bc"
import script from "./EditPR.vue?vue&type=script&lang=js"
export * from "./EditPR.vue?vue&type=script&lang=js"

import "./EditPR.vue?vue&type=style&index=0&id=4471e0bc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__